import { ActionComponent, ActionRegistry } from './types';

// Import action components
import { SetThemeContent, SetThemeHeader } from '@flik/shared';
import NotFoundContent from './not-found/NotFoundContent';
import NotFoundHeader from './not-found/NotFoundHeader';
import { SearchContent } from './search/SearchContent';
import { SearchHeader } from './search/SearchHeader';
import { ShareScreenHeader } from './share-screen/ShareScreenHeader';

export const actionRegistry: ActionRegistry = {
  search: {
    header: SearchHeader,
    content: SearchContent,
  } as ActionComponent,
  'set-theme': {
    header: SetThemeHeader,
    content: SetThemeContent,
  } as ActionComponent,
  'share-screen': {
    header: ShareScreenHeader,
    // No content component - just the header
  } as ActionComponent,
  'not-found': {
    header: NotFoundHeader,
    content: NotFoundContent,
  } as ActionComponent,
};

export const getAction = (key: string) => {
  return actionRegistry[key];
};

export const hasAction = (key: string) => {
  return key in actionRegistry;
};

export const getActionKeys = () => {
  return Object.keys(actionRegistry);
};
